import { render, staticRenderFns } from "./StatisticSettings.vue?vue&type=template&id=5b3ad2e1"
import script from "./StatisticSettings.vue?vue&type=script&lang=js"
export * from "./StatisticSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports